import React, {useState, useEffect, useCallback, useRef} from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import dClient from './../../api/reduxLoaderApi';


import EnhancedTableHead from './TableHeader';

import useStyles from './styles';

import Paper from '@mui/material/Paper';
import * as R from 'ramda';
import {Box, FormControl, MenuItem, Select} from '@mui/material';
import {Pagination} from '@mui/material';
// import { failStatus } from '../../../../../utils/global';
import axios from "axios";
import {strings} from "../../../strings";
import debounce from "../../utils/debuce";
import failStatus from "../../utils/failStatus";
import {useDispatch} from "react-redux";

// import Flags from 'country-flag-icons/react/3x2';

const getItemsByLinkParams = async (link, params, version = 1, dispatch, callback = false) => {
    const res = await dClient('get', link, {params}, {}, version, false);
    if (failStatus(res, dispatch)) return '';
    return callback && callback(res);
};

function getPageSize(total, perpage) {
    const mod = R.mathMod(Number(total), Number(perpage));
    const devided = Math.floor(R.divide(Number(total), Number(perpage)));
    return mod === 0 ? devided : devided + 1;
}

export default function SortableTableMat(props) {
    const {
        headers,
        preParams = null,
        link,
        RowComponent,
        version = 1,
        HeadCompnent,
        keyData = 'data',
        ...others
    } = props;
    const classes = useStyles();
    const dispatch = useDispatch();

    const [items, setItems] = useState([]);
    const [page, setPage] = useState(1);
    const [per_page, setPer_page] = useState(5);
    const [pageSize, setPageSize] = useState(5);
    const [total, setTotal] = useState(5);

    const seter = (res) => {
        const { meta } = res?.data;
        const {per_page, total, current_page,} = meta !== undefined && meta;
        if(meta !== undefined){
            setPage(current_page);
            setPer_page(per_page);
            setPageSize(getPageSize(total, per_page));
            setTotal(total);
        }
        setItems(res.data[keyData]);
    };


    useEffect(() => {
        getItemsByLinkParams(
            link,
            {
                ...preParams,
                page: 1,
                per_page: 8,
            },
            version,
            dispatch,
            seter,
        );

    }, [preParams]);


    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('calories');

    // const [page, setPage] = React.useState(1);
    // const [rowsPerPage, setRowsPerPage] = React.useState(5);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
        // onSortClick(property, !isAsc);
    };

    const handleClick = (event, name) => {
    };

    const handleChangePage = (event, newPage) => {
        getItemsByLinkParams(
            link,
            {
                ...preParams,
                page: newPage,
                per_page: per_page,
            },
            version,
            dispatch,
            seter,
        );
    };

    const handleChangeRowsPerPage = (event) => {
        getItemsByLinkParams(
            link,
            {
                ...preParams,
                page: 1,
                per_page: event.target.value,
            },
            version,
            dispatch,
            seter,
        );
    };

    const refreshTable = () => {
        getItemsByLinkParams(
            link,
            {
                ...preParams,
                page: 1,
                per_page: per_page,
            },
            version,
            dispatch,
            seter,
        );
    };

    return (
        <Box className={classes.root}>
            <Paper className={classes.paper}>
                {/* <EnhancedTableToolbar numSelected={selected.length} /> */}
                <TableContainer>
                    <Table
                        className={classes.table}
                        aria-labelledby="tableTitle"
                        aria-label="enhanced table"
                    >
                        <EnhancedTableHead
                            onRequestSort={handleRequestSort}
                            classes={classes}
                            order={order}
                            orderBy={orderBy}
                            headCells={headers}
                            {...others}
                        />
                        <TableBody>
                            {items?.map((row, index) => {
                                return (
                                    <RowComponent
                                        row={row}
                                        key={`table_index_${row.id}`}
                                        handleClick={handleClick}
                                        refreshTable={refreshTable}
                                        {...others}
                                    />
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
            {per_page !== 5 && <Paper className={classes.paginationRoot}>
                <Pagination
                    color="primary"
                    count={pageSize}
                    page={page}
                    siblingCount={0}
                    onChange={handleChangePage}
                />
                {/*<FormControl className={classes.formControl}>*/}
                {/*  <Select*/}
                {/*    className={classes.selectInput}*/}
                {/*    labelId="demo-simple-select-label"*/}
                {/*    id="demo-simple-select"*/}
                {/*    value={per_page}*/}
                {/*    onChange={handleChangeRowsPerPage}*/}
                {/*  >*/}
                {/*    <MenuItem value={5}>5</MenuItem>*/}
                {/*    <MenuItem value={10}>10</MenuItem>*/}
                {/*    <MenuItem value={15}>15</MenuItem>*/}
                {/*  </Select>*/}
                {/*  <span className={classes.countPerpage}>:تعداد سطرها</span>*/}
                {/*  <span className={classes.countPerpage}>{total}</span>*/}
                {/*  /!* <span className={classes.countPerpage}>:تعداد کل</span> *!/*/}
                {/*  /!* <span className={classes.countPerpage}>*/}
                {/*    <Flags.US*/}
                {/*      title="United States"*/}
                {/*      style={{ height: 16, width: 16 }}*/}
                {/*      className="..."*/}
                {/*    />*/}
                {/*  </span> *!/*/}
                {/*</FormControl>*/}
            </Paper>
            }
        </Box>
    );
}
